













import ReportedIssuesGameSelect from './scripts';

export default ReportedIssuesGameSelect;
